import { render } from "./InformationImage.vue?vue&type=template&id=1521c05e&scoped=true&ts=true"
import script from "./InformationImage.vue?vue&type=script&lang=ts"
export * from "./InformationImage.vue?vue&type=script&lang=ts"

import "./InformationImage.vue?vue&type=style&index=0&id=1521c05e&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/hems-frontend-vue_au_v1.33.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1521c05e"]])

export default __exports__